/* eslint-disable */
export default {
  to: '받는 사람:',
  enterNameOrPhoneNumber: '번호 입력',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
